module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero.7b0899a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/fullscreen-image_hero.png
// module id = +/Dt
// module chunks = 0